<!-- Chip: how many matrices this template is assessed against, and the way in. -->
<button
  type="button"
  class="matrix-chip"
  [class.empty]="selectedCount() === 0"
  [disabled]="isReadOnly()"
  [attr.aria-expanded]="drawerOpen()"
  aria-haspopup="dialog"
  [title]="selectedNames().length ? selectedNames().join(', ') : 'Choose the assessment matrices this form is assessed against'"
  (click)="openDrawer()">
  <i class="pi pi-th-large"></i>
  <span>{{ chipLabel() }}</span>
  @if (!isReadOnly()) {
    <i class="pi pi-chevron-down chip-caret"></i>
  }
</button>

@if (drawerOpen()) {
  <div class="matrix-backdrop" (click)="closeDrawer()">
    <div
      class="matrix-drawer"
      role="dialog"
      aria-label="Assessment matrices"
      (click)="$event.stopPropagation()">
      <div class="drawer-resizer" appDrawerResize="assessment-matrix-drawer-width" [minWidth]="420"></div>

      <div class="drawer-head">
        <div class="drawer-search">
          <input
            type="text"
            class="search-input"
            placeholder="Search matrices by name or description..."
            aria-label="Search assessment matrices"
            [ngModel]="searchText()"
            (ngModelChange)="searchText.set($event)">
          <button type="button" class="modal-close" (click)="closeDrawer()" aria-label="Close" title="Close">
            <i class="pi pi-times"></i>
          </button>
        </div>
        <div class="drawer-meta">
          <span class="selected-count">
            {{ selectedCount() }} selected
          </span>
          @if (selectedCount() > 0) {
            <button type="button" class="clear-all" (click)="clearAll()">Clear all</button>
          }
        </div>
      </div>

      <div class="matrix-list">
        @for (matrix of filteredMatrices(); track matrix.id) {
          <button
            type="button"
            class="matrix-item"
            [class.selected]="isSelected(matrix)"
            (click)="toggle(matrix)">
            <i class="pi" [class.pi-check-square]="isSelected(matrix)" [class.pi-stop]="!isSelected(matrix)"></i>
            <span class="matrix-text">
              <span class="matrix-name">{{ matrix.name }}</span>
              @if (matrix.description) {
                <span class="matrix-description">{{ matrix.description }}</span>
              }
              <span class="matrix-meta">{{ matrix.assessmentType }} · Version {{ matrix.version }}</span>
            </span>
          </button>
        } @empty {
          <p class="matrix-empty">
            @if (searchText()) {
              No matrices match "{{ searchText() }}".
            } @else {
              No assessment matrices are available.
            }
          </p>
        }
      </div>
    </div>
  </div>
}
